import React from 'react'
import PropTypes from 'prop-types'
import {DownloadAssetButton} from 'hec/components/cta'

export const BuilderDownloadAssetButton = ({
    asset,
    fileName,
    ctaText,
    attributes,
    'data-testid': dataTestId
}) => {
    const {className, ...restAttributes} = attributes

    return (
        <DownloadAssetButton
            asset={asset}
            fileName={fileName}
            ctaText={ctaText}
            className={className}
            {...restAttributes}
            data-testid={dataTestId || 'downloadAssetButton-DownloadAssetButton'}
        />
    )
}
BuilderDownloadAssetButton.propTypes = {
    attributes: PropTypes.object,
    asset: PropTypes.string.isRequired,
    fileName: PropTypes.string.isRequired,
    ctaText: PropTypes.string.isRequired,
    'data-testid': PropTypes.string
}
export const DownloadAssetButtonDefinition = {
    component: BuilderDownloadAssetButton,
    name: 'DownloadAssetButton',
    image: 'https://unpkg.com/@mdi/svg@7.4.47/svg/download-box.svg',
    noWrap: true,
    inputs: [
        {name: 'asset', type: 'file', required: true},
        {
            name: 'fileName',
            type: 'string',
            required: true,
            helperText: 'The name of the downloaded file.'
        },
        {name: 'ctaText', type: 'string', required: true}
    ]
}
